import LuckyDrawDetailPreviewPanel from "./luckyDrawDetailPreviewPanel.container";

export default LuckyDrawDetailPreviewPanel;
